@if (showShellHeader) {
    <header class="app-header">
        <div class="brand-logo">
            <img src="assets/icons/icon-192.png" alt="Logo" class="header-icon">
            <h1>BabyMonitor<span class="live-badge">.live</span></h1>
        </div>
    </header>
}
<main>
    <router-outlet></router-outlet>
</main>